module.exports = __webpack_public_path__ + "static/img/sharecodecouponmore.2d6d4a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/sharecodecouponmore.png
// module id = xUw0
// module chunks = 0